import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function Loader() {
  const { t } = useTranslation('homepage');
  const [isLoading, setIsLoading] = useState(true);
  const [isFadingOut, setIsFadingOut] = useState(false);
  
  const slogan = {
    title: "Building homes is wonderful",
    subtitle: "Building homes with love is art"
  };

  useEffect(() => {
    // Hide loader when page is fully loaded
    const handleLoad = () => {
      setTimeout(() => {
        setIsFadingOut(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 500); // Fade out duration
      }, 1500); // Show loader for at least 1.5 seconds
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, []);

  if (!isLoading) {
    return null;
  }

  return (
    <div
      className="loader-wrap"
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: '#ffffff',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        opacity: isFadingOut ? 0 : 1,
        transition: 'opacity 0.5s ease-out'
      }}
    >
      {/* Inline styles for animations to avoid external CSS dependency */}
      <style>{`
        @keyframes gridPan { 0% { background-position: 0 0, 0 0; } 100% { background-position: 80px 60px, 160px 120px; } }
        @keyframes drawStroke { 0% { stroke-dashoffset: 400; opacity: .6; } 70% { opacity: 1; } 100% { stroke-dashoffset: 0; opacity: 1; } }
        @keyframes fadeUp { 0% { opacity: 0; transform: translateY(8px); } 100% { opacity: 1; transform: translateY(0); } }
        @keyframes fadeOut { 0% { opacity: 1; } 100% { opacity: 0; } }
        @keyframes loadBar { 0% { width: 0%; } 100% { width: 100%; } }
        @media (max-width: 768px) {
          .loader-slogan-title { font-size: 24px !important; letter-spacing: 1px !important; }
          .loader-slogan-subtitle { font-size: 20px !important; letter-spacing: 2px !important; }
        }
        @media (max-width: 480px) {
          .loader-slogan-title { font-size: 20px !important; letter-spacing: 1px !important; }
          .loader-slogan-subtitle { font-size: 18px !important; letter-spacing: 1.5px !important; }
        }
      `}</style>

      {/* Blueprint grid background */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage:
            'repeating-linear-gradient(0deg, rgba(191,129,80,.08) 0 1px, transparent 1px 60px), repeating-linear-gradient(90deg, rgba(191,129,80,.08) 0 1px, transparent 1px 80px)',
          animation: 'gridPan 10s linear infinite'
        }}
      />

      {/* Background skyline illustration */}
    

      {/* Center content */}
      <div style={{ position: 'relative', zIndex: 2, textAlign: 'center', maxWidth: '600px', margin: '0 auto', padding: '0 20px' }}>
        {/* Slogan */}
        <div className="loader-slogan-title" style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '32px', letterSpacing: '2px', color: '#222', lineHeight: '1.4', marginBottom: '16px' }}>
          <div style={{
            animation: 'fadeUp .8s ease forwards',
            animationDelay: '0.2s',
            opacity: 0
          }}>
            {slogan.title}
          </div>
        </div>
        
        <div className="loader-slogan-subtitle" style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '28px', letterSpacing: '3px', color: 'rgb(73, 69, 56)', lineHeight: '1.4' }}>
          <div style={{
            animation: 'fadeUp .8s ease forwards',
            animationDelay: '0.5s',
            opacity: 0
          }}>
            {slogan.subtitle}
          </div>
        </div>

        {/* Subtle loading bar */}
        <div style={{ width: 200, height: 2, backgroundColor: 'rgba(0,0,0,0.08)', margin: '24px auto 0', borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ height: '100%', backgroundColor: 'rgb(73, 69, 56)', animation: 'loadBar 1.8s ease-in-out infinite' }} />
        </div>
      </div>
    </div>
  );
}

export default Loader;
